import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';

const DonateButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [gradientIndex, setGradientIndex] = useState(0);

  // Set a scroll threshold to show/hide the donate button
  const scrollThreshold = 150;

  // Track the scroll position
  const handleScroll = () => {
    if (window.scrollY > scrollThreshold) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Change gradient color every 2 seconds
  useEffect(() => {
    const gradientInterval = setInterval(() => {
      setGradientIndex((prevIndex) => (prevIndex + 1) % 2); // Only two gradients
    }, 2000); // Change gradient every 2 seconds

    // Cleanup the interval on unmount
    return () => {
      clearInterval(gradientInterval);
    };
  }, []);

  // Add event listener for scroll on component mount
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Two gradient colors
  const gradients = [
    'linear-gradient(to right,rgb(0, 0, 0),rgb(48, 48, 48))', // First gradient
    'linear-gradient(to right,rgb(0, 146, 29),rgb(0, 200, 43))', // Second gradient
  ];

  // Select the current gradient
  const currentGradient = gradients[gradientIndex];

  return (
    <Box
      className={`fixed right-0 top-1/2 transform -translate-y-1/2 z-50 transition-all duration-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`} // Button fades in and out based on scroll
      sx={{
        animation: 'pulseAnimation 3s infinite, scaleUp 1s ease-in-out', // Added pulse animation and scale-up effect
      }}
    >


      <a
          href="https://donate.akhuwat.org.pk/" target="_blank" rel="noopener noreferrer"
   
          className="text-white h-10 px-3 py-3 flex items-center justify-center font-manrope
          text-[16px] font-bold leading-[28px] shadow-lg transition-all duration-300 text-white"
              style={{
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.3)',
                background: currentGradient, // Apply the gradient background
                transform: 'rotate(90deg)', // Rotate the button by 90 degrees
                transformOrigin: 'center', // Ensure rotation occurs around the center
                borderTopLeftRadius: '10px', // Round the top-left corner
                borderBottomLeftRadius: '10px', // Round the bottom-left corner
                borderTopRightRadius: '10px', // Keep the top-right corner square
                borderBottomRightRadius: '10px', // Keep the bottom-right corner square
              }}
       
        
        >
          Donate
        </a>
    </Box>
  );
};

export default DonateButton;
